<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{$t($route.meta.title)}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <bc-btn-add
                                @invoke-method="openRepack()"
                                :tooltip="$t('lang.add_repack')"
                            ></bc-btn-add>
                            <bc-btn-mobile-nav
                                @invoke-method="invokeMethod($event)"
                                :mobile-list="mobile_list"
                            ></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>

                <v-card-text :class="$bp.smallScreen ? 'px-1 pb-1 pt-3' : 'py-3'">
                    <v-card elevation="10">
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs12 text-center>
                                    <h2>{{ $t('lang.invoice') }}</h2>
                                </v-flex>
                                <v-flex xs6 align-self-start>
                                    <v-layout row wrap inner-layout pt-3>
                                        <v-flex xs4 sm2>Voice: </v-flex>
                                        <v-flex xs8 sm10>419-999-9999</v-flex>
                                        <v-flex xs4 sm2>Fax: </v-flex>
                                        <v-flex xs8 sm10>419-888-8888</v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs6 align-self-start text-right>
                                    <span class="fs-14">{{ $t('lang.invoice_and_packing') }}</span>
                                    <span class="fs-18">99999</span>
                                    <span>{{ $t('lang.invoice_date') }}</span>
                                    <span class="fs-18">{{ current_day }}</span>
                                </v-flex>
                                <v-flex xs6 mt-3 align-self-start>
                                    <span class="ml-3 fs-14 fw-bold">Sold To</span>
                                    <span class="ml-4 fs-16">{{ currObjField('company') || '---' }}</span>
                                    <span class="ml-4 fs-16">{{ currObjField('sold_to_address') || '---' }}</span>
                                </v-flex>
                                <v-flex xs6 mt-3 align-self-start>
                                    <span class="ml-3 fs-14 fw-bold">Ship To</span>
                                    <span class="ml-4 fs-16">{{ currObjField('company') || '---' }}</span>
                                    <span class="ml-4 fs-16">{{ currObjField('ship_to_address') || '---' }}</span>
                                </v-flex>
                                <v-flex xs12 align-self-start mt-3>
                                    <v-layout row wrap inner-layout>
                                        <v-flex xs2 fw-bold>Customer PO</v-flex>
                                        <v-flex xs2 fs-16>{{ currObjField('po_number') || 'NONE' }}</v-flex>
                                        <v-flex xs2 fw-bold>Bill Of Lading</v-flex>
                                        <v-flex xs2 fs-16>{{ currObjField('bill_of_lading') || 'NONE' }}</v-flex>
                                        <v-flex xs2 fw-bold>CARRIER</v-flex>
                                        <v-flex xs2 fs-16>{{ currObjField('carrier') || '---' }}</v-flex>
                                        <v-flex xs2 fw-bold>Sales Rep</v-flex>
                                        <v-flex xs2 fs-16>{{ currObjField('salesman') }}</v-flex>
                                        <v-flex xs2 fw-bold>Date Shipped</v-flex>
                                        <v-flex xs2 fs-16>{{ currObjField('date_shipped') || '---' }}</v-flex>
                                        <v-flex xs2 fw-bold>Payment Terms</v-flex>
                                        <v-flex xs2 fs-16>{{ currObjField('payment_terms_description') || 'NONE' }}</v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
            <bc-dialog :value="repack_dialog" max-width="900">
                <v-card>
                    <v-card-title>
                        <span class="headline">{{ currObjField('repack_id') ? $t('lang.edit_repack') : $t('lang.add_repack') }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeRepackDialog"
                            :dialog-status="repack_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text>
                        <v-form ref="repack" @submit.prevent>
                            <v-data-table
                                v-model="selected_repacks"
                                :headers="repacks_headers"
                                :items="repacks || []"
                                item-key="repack_id"
                                :no-data-text="$t('lang.no_results_matching')"
                                hide-actions
                                select-all
                            >
                                <template slot="items" slot-scope="props">
                                    <tr :active="props.selected">
                                        <td>
                                            <v-checkbox
                                                @click.stop="props.selected = !props.selected"
                                                :input-value="props.selected"
                                                primary
                                                hide-details
                                            ></v-checkbox>
                                        </td>
                                        <td>{{ props.item.company }}</td>
                                        <td>{{ props.item.customer_part_number }}</td>
                                        <td>{{ props.item.name }}</td>
                                        <td>---</td>
                                        <td>---</td>
                                        <td>---</td>
                                    </tr>
                                </template>
                            </v-data-table>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeRepackDialog()">{{$t('lang.cancel')}}</v-btn>
                        <v-btn color="success">{{$t('lang.save')}}</v-btn>
                    </v-card-actions>
                </v-card>
            </bc-dialog>
        </v-container>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { store } from "Store/store";

export default {
    data() {
        return {
            headers: [
                { text: this.$t("lang.company_id"), sortable: false, width: "25%" },
                { text: this.$t("lang.invoice_id"), sortable: false, width: "15%" },
                { text: this.$t("lang.date_shipped"), sortable: false, width: "25%" },
                { text: this.$t("lang.total"), sortable: false, width: "10%" },
                { text: this.$t("lang.sent"), sortable: false, width: "15%" },
            ],
            repacks_headers: [
                { text: this.$t("lang.customer"), sortable: false, width: "20%" },
                { text: this.$t("lang.part_number"), sortable: false, width: "15%" },
                { text: this.$t("lang.part_name"), sortable: false, width: "20%" },
                { text: this.$t("lang.total_removed"), sortable: false, width: "15%" },
                { text: this.$t("lang.total_processed"), sortable: false, width: "15%" },
                { text: this.$t("lang.qty"), sortable: false, width: "15%" },
            ],
            repack_dialog: false,
            customers: null,
            selected_invoices: [],
            selected_repacks: [],
            invoice: {
                company_id: "",
                sold_to_address_id: "",
                ship_to_address_id: "",
                po_number: "",
                salesman_id: "",
                bol_id: "",
                shipping_method_id: "",
                date_shipped: "",
                date_due: "",
                carrier_ud: "",
                payment_term_id: "",
                invoice_sent: "",
            },
            current_obj: null,
            filter: {
                search: "",
                company_id: "",

                page_size: 0,
                page_num: 0,
            },
            invoice_dialog: false,
            mobile_list: [{ title: this.$t("lang.add_new"), action: "showInvoice" }, { title: this.$t("lang.refresh"), action: "dbGetInvoices" }],
            dbGetInvoices: _.debounce(this.getInvoices, 1500, { maxWait: 1500, leading: true, trailing: false }),
        };
    },
    beforeRouteEnter(to, from, next) {
        const part = new Promise((resolve, reject) => {
            store
                .dispatch("fetchPart", {
                    url: "parts/" + to.params.id,
                    method: "get",
                    stateProperty: "part",
                    dataProperty: "parts",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.parts ? resolve(data.parts) : reject(new Error("reject"));
                });
        });
        Promise.all([part])
            .then(([part]) => {
                next((vm) => {
                    vm.$store.commit("toggleModalLoader", false);
                    vm.assignObj(vm.invoice, part);
                    vm.finishLoader();
                    // TODO: based on perms can delete authorized fields from part object
                    vm.editStatus = {
                        status: part.status,
                    };
                });
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, don't go to route, else set variables and proceed to route
            });
    },
    beforeRouteUpdate(to, from, next) {
        const part = new Promise((resolve, reject) => {
            this.$store
                .dispatch("fetchPart", {
                    url: "parts/" + to.params.id,
                    method: "get",
                    stateProperty: "part",
                    dataProperty: "parts",
                    commit: true,
                })
                .then((data) => {
                    typeof data !== "undefined" && data.parts ? resolve(data.parts) : reject(new Error("reject"));
                });
        });

        Promise.all([part])
            .then(([part]) => {
                this.$store.commit("toggleModalLoader", false);
                this.finishLoader();
                this.assignObj(this.invoice, part);
                next();
            })
            .catch((error) => {
                next({ name: "dashboard", replace: true }); //if any of them error, path to dashboard
            });
    },
    computed: {
        ...mapState({
            rules_invoice: (state) => state.validation.rules_invoice,
            default_filter: (state) => state.invoices.invoices_filter,
            page: (state) => state.invoices.page,
            invoices: (state) => state.invoices.invoices,
            part_profile: (state) => state.parts.part,
            repacks: (state) => state.repack.repacks,
        }),
        axiosParams() {
            return this.prepareParams(this.filter, this.default_filter);
        },
        currObjField() {
            return (field) => {
                return this.part_profile && field && this.part_profile[field] ? this.part_profile[field] : "";
            };
        },
    },
    methods: {
        getRepacks() {
            this.$store.commit("toggleModalLoader", true);
            this.$store
                .dispatch("fetchRepack", {
                    url: "repack",
                    method: "get",
                    stateProperty: "repacks",
                    dataProperty: "repack",
                    commit: true,
                })
                .then((data) => {
                    this.$store.commit("toggleModalLoader", false);
                });
        },
        closeRepackDialog() {
            this.repack_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        openRepack() {
            this.$store.commit("validationOn");
            if (this.repacks == null) this.getRepacks();
            this.$nextTick(() => {
                this.repack_dialog = true;
            });
        },
        getArrayData() {
            // if(this.customers == null) this.getCustomers();
            if (this.parts == null) this.getParts();
        },
        closeInvoiceDialog() {
            this.invoice_dialog = false;
            this.$refs.delete_invoice.close();
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        getInvoices() {
            this.startLoader();
            this.$store
                .dispatch("fetchInvoice", {
                    url: "invoices",
                    method: "get",
                    stateProperty: "invoices",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.invoice_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        getCustomers() {
            this.$store
                .dispatch("fetchCustomers", {
                    url: "customers",
                    method: "get",
                })
                .then((data) => {
                    if (typeof data !== "undefined") {
                        this.customers = data.customers;
                    }
                });
        },
        modifyInvoice(method = null, id = null) {
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("invoice")) {
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchInvoice", {
                                pk: "invoice_id",
                                id: id,
                                url: `invoices/${id ? id : ""}`,
                                method: method,
                                stateProperty: "invoices",
                                mutate: true,
                                body: this.invoice,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeInvoiceDialog();
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        getParts() {
            this.$store.dispatch("fetchPart", {
                url: "parts",
                method: "get",
                stateProperty: "parts",
                commit: true,
            });
        },
        showInvoice(item = null) {
            this.current_obj = item;
            this.getArrayData();

            if (this.$refs.invoice) item ? this.$refs.invoice.resetValidation() : this.$refs.invoice.reset();

            this.$nextTick(() => {
                this.assignObj(this.invoice, item, this.rules_invoice);
                this.invoice_dialog = true;
            });
        },
    },
};
</script>
